import React, { useState } from 'react'
import useSortedGraph from '../../../hooks/useSortedGraph'
import { useProject } from '../../../context/project'
import Modal from '../../Modal'
import { capitalize } from '../../../utils/tools'
import TooltipButton from '../../ui/TooltipButton'
import { Typography, CardMedia } from '@mui/material'
import { HighlightOffSharp, ControlPointSharp, StarsSharp } from '@mui/icons-material'
import styles from "./DiscoverModal.module.scss"
import { DiscoverCardImage } from './DiscoverCardImage.js'

const buttonSrc = (isActive) => !isActive ? <ControlPointSharp fontSize='large'/>: <HighlightOffSharp fontSize='large'/>

const TopRated = (isTopRated) => {
    return (
        isTopRated && 
            <div className={styles['top-rated']}>
                <div className={styles['top-rated-star']}>
                    <StarsSharp fontSize='small' color='watchList'/> 
                </div>
                Top Rated
            </div>
    )
}

const Field = (name, value) => <Typography classes={{root: styles['field']}} variant="h4">{name}: <span>{value}</span></Typography>



export default function DiscoverCard({description, isTopRated, color, dataset, website, handleUpdate, isActive, handleRemove, dataType, frequency, monthlyChange, lastUpdated}) {
    const [ open, setOpen ] = useState(false)
    const { ticker, privateCompany } = useProject()
    const { layer } = useSortedGraph(ticker, dataset.datasetValue, dataset.columnValue, privateCompany, open)
    const props = {description, isTopRated, color, dataset, website, isActive, dataType, frequency, layer}

    const handleClick = (e) => {
        e.stopPropagation()
        isActive ? handleRemove(dataset) : handleUpdate(dataset)
        handleClose()
    }

    const handleOpen = () => setOpen(true)
    
    const handleClose = () => setOpen(false)
    const discoveryImg = DiscoverCardImage(dataType)

    return (
        <>
            <div elevation={4} onClick={handleOpen} className={`${styles['card']} ${isActive ? styles['active-border'] : ''}`}>
                <CardMedia
                    component="img"
                    alt={dataset?.columnName}
                    height="140"
                    image={discoveryImg}
                />
                <button className={styles['click-button']} onClick={handleClick}>{buttonSrc(isActive)}</button>
                <Typography style={{backgroundColor: color}} classes={{root: styles[`img-tag`]}}>{dataset?.datasetName}</Typography>
                <div className={styles['card-content']}>
                    <Typography variant="h4">{dataset?.columnName}</Typography>
                    <Typography variant="body2">{description}</Typography>
                </div>
                <div className={styles['footer']}>
                    {TopRated(isTopRated)}
                </div>
            </div>
            {open && <MoreInfo open={open} handleClose={handleClose} handleClick={handleClick} {...props}/>}
        </>
    )
}

export const MoreInfo = ({open, description, isTopRated, dataset, website, isActive, handleClose, dataType, frequency, handleClick, change, layer, lastUpdate}) => {
    return (
        <Modal open={open} handleClose={handleClose} hideHeader={true}>
            <div className={styles['pop-up']}>
                <div className={styles['pop-up-header']}>
                    <div>
                        <Typography variant="h2">{dataset?.columnName}</Typography>
                        <div className={styles['mini-title']}>
                            {website && <a href={website} target="_blank" rel="noopener noreferrer">
                                {website}
                            </a>}
                            {TopRated(isTopRated)}
                        </div>
                    </div>
                    <TooltipButton elevation={8} onClickFunc={handleClick} title={isActive ? 'Remove' : 'Add'}>
                        {buttonSrc(isActive)}
                    </TooltipButton>
                </div>
                <div>
                    {Field('Data Type', dataType)}
                    {Field('Data Frequency', capitalize(frequency))}
                    {Field('Description', description)}
                    {Field('Last Date', new Date(lastUpdate).toLocaleDateString())}
                </div>
            </div>
        </Modal>
    )
}